/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable jquery-unsafe/no-html */
/* eslint-disable jquery-unsafe/no-append */
/* eslint-disable jquery-unsafe/no-before */
/* eslint-disable jquery-unsafe/no-prepend */
import CssSlurper from '@intercom/embercom-composer/lib/css-slurper';
import CssTransformer from '@intercom/embercom-composer/lib/css-transformer';
import getStylesheetProperties from '@intercom/embercom-composer/lib/get-stylesheet-properties';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import $ from 'jquery';
function InlinedTemplateGenerator(wrapperSelector) {
  this.wrapperSelector = wrapperSelector;
  this.slurper = null;
  this.cssTransformer = new CssTransformer();
}
InlinedTemplateGenerator.prototype = {
  process(iframe, options) {
    let $iframeHtml = $(iframe).contents().find('html');
    let $resultHtml = $iframeHtml.clone();
    let cssPropertyTrustedlist = [];
    let cssPropertyBlocklist = ['width', 'height', 'direction', '-webkit-text-fill-color', '-webkit-user-modify'];
    let inlineStartSelector = options && options.inlineStartSelector || '';
    let ignoredElements = options && options.ignoredElements || [];
    $iframeHtml = inlineStartSelector ? $iframeHtml.find(inlineStartSelector) : $iframeHtml;
    $resultHtml = inlineStartSelector ? $resultHtml.find(inlineStartSelector) : $resultHtml;
    let combinedStylesheet = this._getCombinedStyles($iframeHtml, iframe);
    cssPropertyTrustedlist = this._generatecssPropertyTrustedlist(combinedStylesheet.stylesheet);
    this._addStylesheetToHtml($resultHtml, combinedStylesheet.text);
    this.slurper = new CssSlurper({
      trustedlist: cssPropertyTrustedlist,
      blocklist: cssPropertyBlocklist
    });
    this._addContentStyles($iframeHtml, $resultHtml);
    this._inlineStylesIntoTemplate($iframeHtml, $resultHtml, ignoredElements);
    this._processHeadTag($resultHtml);
    this._processStyleTags($resultHtml);
    this._addScopedStyles($resultHtml, combinedStylesheet.stylesheet, iframe);
    return this._cleanUpTemplateAndConvertTags($iframeHtml, $resultHtml);
  },
  _generatecssPropertyTrustedlist(stylesheet) {
    return getStylesheetProperties(stylesheet);
  },
  _addContentStyles($html, $targetHtml) {
    let contentStyles = this._generateContentStyle($html);
    if (contentStyles) {
      let $styleHookElement = $targetHtml.find('style').last().length ? $targetHtml.find('style').last() : $('body').children().first();
      let insertAction = $targetHtml.find('style').last().length ? 'after' : 'before';
      $styleHookElement[insertAction](`<style id="ic-content-styles">${contentStyles}</style>`);
    }
  },
  _inlineStylesIntoTemplate($html, $targetHtml, ignoredElements) {
    let self = this;
    let elementsToIgnore = '*:not(head, title, meta, style, script, link)';
    let $targetContents = $targetHtml.find(elementsToIgnore).addBack();
    let $htmlContents = $html.find(elementsToIgnore).addBack();
    $htmlContents.each(function (index) {
      let cssRules = self._getElementStyles(this);
      let targetElement = $targetContents[index];
      if (cssRules.length && self._shouldInlineElement(targetElement, ignoredElements)) {
        targetElement.style.cssText = cssRules + targetElement.style.cssText;
      }
    });
  },
  _shouldInlineElement(element, ignoredElements) {
    let shouldInline = true;
    for (let i = 0, length = ignoredElements.length; i < length; i++) {
      let ignoredElement = ignoredElements[i];
      if ($(element).is(ignoredElement)) {
        shouldInline = false;
        return false;
      }
    }
    return shouldInline;
  },
  _reinsertContentPlaceholder($html) {
    let $templateContent = $html.find('#ic-template-content');
    if ($templateContent.length) {
      $templateContent.parent()[0].insertBefore(document.createTextNode('{{content}}'), $templateContent[0]);
      $templateContent.remove();
    }
  },
  _removeBlockContent($html, $targetHtml) {
    $html.find('#ic-blocks-content').empty();
    $targetHtml.find('#ic-blocks-content').remove();
  },
  _processHeadTag($html) {
    /* pat - This lint rule is okay to disable as we are just moving existing elements around */
    /* eslint-disable-next-line jquery-unsafe/no-prependTo */
    $html.find('head').find('link, style').prependTo($html.find('body'));
    $html.find('head').remove();
  },
  _getCombinedStyles($html, iframe) {
    let stylesheet;
    let stylesheets = Object.values(iframe.contentDocument.styleSheets);
    let styleSheetText = '';
    let $body = $html.find('body');
    for (let stylesheet of stylesheets) {
      if (stylesheet.cssRules[0].type === 3) {
        styleSheetText = stylesheet.ownerNode.innerText + styleSheetText;
      } else {
        styleSheetText += stylesheet.ownerNode.innerText;
      }
    }
    $body.append(sanitizeHtml(`<style type="text/css" id="ic-combined-styles">${styleSheetText}</style>`, {
      config: 'email'
    }).string);
    stylesheets = iframe.contentDocument.styleSheets;
    stylesheet = {
      stylesheet: stylesheets[stylesheets.length - 1],
      text: styleSheetText
    };
    $html.find('#ic-combined-styles').remove();
    return stylesheet;
  },
  _processStyleTags($html) {
    let $body = $html.find('body');
    let templateStyles = $html.find('style').not('#ic-content-styles').contents().text();
    if ($body.length) {
      this._inlineBodyTagStyles($body);
    }
    $html.find('style').not('#ic-content-styles').remove();
    if (templateStyles) {
      let $positionToInputContentStyles = $html.find('#ic-content-styles').length ? $html.find('#ic-content-styles') : $body;
      if (templateStyles) {
        $positionToInputContentStyles.before(sanitizeHtml(`<style id="ic-template-styles">${templateStyles}</style>`, {
          config: 'email'
        }).string);
      }
    }
  },
  _addScopedStyles($html, stylesheet, iframe) {
    if (stylesheet.cssRules.length > 0) {
      let scopedStyles = this._scopeCssRules(stylesheet, iframe);
      $html.find('#ic-template-styles').text(scopedStyles);
      return;
    }
    $html.find('#ic-template-styles').remove();
  },
  _cleanUpTemplateAndConvertTags($iframeHtml, $targetHtml) {
    let template;
    this._reinsertContentPlaceholder($iframeHtml);
    this._reinsertContentPlaceholder($targetHtml);
    this._removeBlockContent($iframeHtml, $targetHtml);
    template = $targetHtml[0].outerHTML;
    return template.replace(/<html/g, '<div class="ic-custom-html"').replace(/<body/g, '<div class="ic-custom-body"').replace(/<\/html>/g, '</div>').replace(/<\/body>/g, '</div>').replace(/ hasbrowserhandlers="true"/g, '').replace(/<!DOCTYPE[^>]+>/i, '');
  },
  _getElementStyles(element) {
    return this.slurper.getStyles(element);
  },
  _scopeCssRules(stylesheet, iframe) {
    return this.cssTransformer.transform(stylesheet, iframe.contentWindow);
  },
  _removeTemporaryIframes() {
    $('[id^="tempstyles"]').remove();
  },
  _addInlinedHtmlToTemplate($html, $iframe) {
    let $fakeBody = $html.find('.ic-custom-body');
    let $body = $iframe.contents().find('body');
    let templateHtmlWithInlinedStyles = $body.html();
    $fakeBody.html(sanitizeHtml(templateHtmlWithInlinedStyles, {
      config: 'email'
    }).string);
  },
  _inlineBodyTagStyles($body) {
    let style = '';
    let marginWidth;
    let marginHeight;
    let body = $body[0];
    let bodyStyle = this._getElementStyles(body);
    if (body) {
      if (body.getAttribute('topmargin') || body.getAttribute('marginheight')) {
        marginHeight = body.getAttribute('topmargin') !== undefined ? body.getAttribute('topmargin') : body.getAttribute('marginheight');
        marginHeight = marginHeight.indexOf('px') === -1 && marginHeight > 0 ? `${marginHeight}px` : marginHeight;
        style += `margin-top: ${marginHeight};`;
        style += `margin-bottom: ${marginHeight};`;
      }
      if (body.getAttribute('leftmargin') || body.getAttribute('marginwidth')) {
        marginWidth = body.getAttribute('leftmargin') !== undefined ? body.getAttribute('leftmargin') : body.getAttribute('marginwidth');
        marginWidth = marginWidth.indexOf('px') === -1 && marginWidth > 0 ? `${marginWidth}px` : marginWidth;
        style += `margin-left: ${marginWidth};`;
        style += `margin-right: ${marginWidth};`;
      }
      if (body.getAttribute('bgcolor')) {
        style += `background-color: ${body.getAttribute('bgcolor')};`;
      }
    }
    if (style || bodyStyle) {
      body.style.cssText = bodyStyle + style;
    }
  },
  _generateContentStyle($html) {
    let styles = '';
    styles += this._generateElementAndDescendentStyle($html.find('#ic-template-content').children());
    return styles;
  },
  _generateElementAndDescendentStyle($children) {
    let self = this;
    let styles = '';
    $children.each(function () {
      let $thisElement = $(this);
      styles += self._generateElementStyle(this);
      if ($thisElement.children().length) {
        styles += self._generateElementAndDescendentStyle($thisElement.children());
      }
    });
    return styles;
  },
  _generateElementStyle(element) {
    return `${this._generateSelector(element)}{${this._getElementStyles(element)}}`;
  },
  _generateSelector(element, selector) {
    selector = selector || '';
    selector = `${element.tagName.toLowerCase()} ${selector}`;
    if (element.parentNode.id !== 'ic-template-content') {
      selector = this._generateSelector(element.parentNode, selector);
    } else {
      selector = this.wrapperSelector.length ? `${this.wrapperSelector} ${selector}` : selector;
    }
    return selector;
  },
  _addStylesheetToHtml($html, styles) {
    $html.find('body').prepend(sanitizeHtml(`<style id="combined-styles">${styles}</style>`, {
      config: 'email'
    }).string);
    $html.find('style:not(#combined-styles)').remove();
  }
};
export default InlinedTemplateGenerator;